/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import styled from "styled-components";

import { FontSizes, FontWeights, IStackTokens, ITextStyles } from "@fluentui/react";

/**
 * Stack tokens for the cancel/save buttons
 */
export const buttonStackTokens: IStackTokens = { childrenGap: 40, padding: 30 };

/**
 * FormikDatePicker
 */
export const datePickerFieldStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
  },
  textField: {
    fontSize: FontSizes.xLargePlus,
    lineHeight: FontSizes.xxLargePlus,
  },
};

export const FieldSet = styled.fieldset`
  padding: 10px;
`;

/**
 * Styled div to wrap around label and input fields
 */
export const FieldBlock = styled.div`
  width: 47%;

  input,
  textarea {
    width: 100%;
  }
`;

/**
 * Section title styles to distinguish each grouping of fields witin form
 */
export const formSectionTitleStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.medium,
    fontWeight: FontWeights.semibold,
    margin: "1.5rem 0 0.5rem",
    width: "100%",
  },
};

/**
 * Horizontal form field stack tokens
 */
export const horizontalFormFieldsStackTokens: IStackTokens = { childrenGap: 15 };

/**
 * Subtitle text used within sections to differentiate arry of items being updated
 */
export const sectionSubtitleStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.medium,
    fontWeight: FontWeights.semibold,
    margin: "1rem 0 0.5rem",
  },
};

export const toggleFieldStyles = {
  root: {
    marginBottom: 0,
    display: "flex",
    alignItems: "center",
  },
};

export const ShippingSameRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

/**
 * Text styles for Shipping address same question
 */
export const shippingSameLabelStyles = {
  root: {
    fontSize: FontSizes.medium,
    fontWeight: FontWeights.semibold,
  },
};

export const ShippingSameSwitch = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 30px;
`;

export const IsSocialMediaPrivateRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const IsSocialMediaPrivate = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 30px;
`;

export const isSocialMediaPrivateLabelStyles = {
  root: {
    fontSize: FontSizes.medium,
    fontWeight: FontWeights.semibold,
  },
};
